module.exports = __webpack_public_path__ + "img/total-file-drop.6a6f326e.svg";